import { render, staticRenderFns } from "./ReleaseFileUploader.vue?vue&type=template&id=21673795"
import script from "./ReleaseFileUploader.vue?vue&type=script&lang=js"
export * from "./ReleaseFileUploader.vue?vue&type=script&lang=js"
import style0 from "./ReleaseFileUploader.vue?vue&type=style&index=0&id=21673795&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports